import React, {
	Component
} from 'react';
import styled from 'styled-components';
import { store } from '../stores/mainStore';

const config = window.dodConfig;

const FaqPage = styled.div`
	/* margin-top: 35%; */
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	padding-top: ${p => config.isLandscape ? 25 : 100}px;
	pointer-events: auto;
`

const Content = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`

const CloseBox = styled.div`
	position: relative;
	display: inline-block;
	width: ${p => config.isLandscape ? 40 : 90}%;
	height: ${p => config.isLandscape ? 90 : 76}%;
	margin: 0 auto;
`

const BoxContent = styled.div`
	width: 100%;
	height: 100%;
	overflow: auto;
	background-color: white;
	color: black;
`

const CloseButton = styled.img`
	width: 12%;
	position: absolute;
	top: -15px;
	right: -15px;
`
const Faq = styled.img`
	width: 100%;
`

const Blue = styled.div`
	padding: 3% 1.5%;
	background: radial-gradient(circle, rgba(93,120,255,1) 0%, rgba(36,64,200,1) 100%);
	background-position: 25% 25%;
	width: 100%;
	height: 100%;
`

export class ModalFaq extends Component {

	continue(){
		window.manager.playAudio("poopPop");
		store.modal = '';
	}

	learn(){
		store.modal = 'learn';
	}

	render() {
		return (
			<FaqPage>
				<Content>
					<CloseBox>
						<Blue>
							<CloseButton src="/assets/btn_close.png" onClick={e => this.continue()}/>
							<BoxContent>
								<Faq src="/assets/R7 Help Guide - FINAL.jpg"/>
							</BoxContent>
						</Blue>
					</CloseBox>
				</Content>
			</FaqPage>
		)
	}
}